import {
  activeRouteClaim,
  catalogHref,
  preservesOnAccountSwitch,
  remotePathname,
  rewriteOnAccountSwitch,
  type RouteClaimTable,
  shellPathname,
} from '../routeClaims';
import {currentProductForPath} from '../header/forgeProducts';

/** Shell path to navigate to after switching to `account`, or null to stay put. */
export function accountSwitchTarget(
  pathname: string,
  table: RouteClaimTable,
  account: {name: string}
): string | null {
  const active = activeRouteClaim(table, pathname);
  if (!active) {
    return null;
  }
  const remotePath = remotePathname(active.routeClaim, pathname);
  if (preservesOnAccountSwitch(active.routeClaim, remotePath)) {
    return null;
  }
  const rewritten = rewriteOnAccountSwitch(
    active.routeClaim,
    remotePath,
    account.name
  );
  if (rewritten !== undefined) {
    return shellPathname(active.remote.routeClaims, rewritten);
  }
  const product = currentProductForPath(pathname, table);
  return (product && catalogHref(product, table)) ?? '/';
}
